import {twMerge} from '@sdox/utils'

import type {KeyValueData} from './KeyValueTable'

export interface KeyValueTableRowProps {
  data: KeyValueData
  alignValue?: 'START' | 'END'
}

export const KeyValueTableRow = (props: KeyValueTableRowProps) => {
  const {
    data,
    alignValue = 'END',
  } = props

  const dataClassName = twMerge(
    'text-p1',
    alignValue === 'START' && '@block-medium:text-start',
    alignValue === 'END' && '@block-medium:text-end',
  )

  return (
    <div className={'grid grid-cols-1 gap-spacing-4 py-spacing-32 @block-medium:grid-cols-2 @block-medium:gap-spacing-32'}>
      <span className={'text-p1-emphasized'}>
        {data.label}
      </span>
      <span className={dataClassName}>
        {data.data}
      </span>
    </div>
  )
}
